import { toast, ToastPosition, TypeOptions } from 'react-toastify'
class ToastService {
    private toast: typeof toast
    constructor() {
        this.toast = toast
    }

    show(
        message: string,
        type: TypeOptions = 'default',
        position: ToastPosition = 'top-right'
    ) {
        return this.toast.success(message, {
            position,
            type,
        })
    }
}

const toastService = new ToastService()

export const showToast = (
    message: string,
    type: TypeOptions = 'default',
    position: ToastPosition = 'top-right'
) => {
    toastService.show(message, type, position)
}
